import { Container } from './Banner.style.js';

export const Banner = ({ margin, children, bgColor, textColor }) => (
  <Container bgColor={bgColor} textColor={textColor} margin={margin}>
    <span>{children}</span>
  </Container>
);
